{
	"page": {
		"subtitle": "What's new",
		"intro": "What changed in each version, newest first.",
		"current": "{{app}} is on version {{version}}.",
		"appsLabel": "Apps",
		"loading": "Loading",
		"retry": "Retry",
		"empty": "No changes yet.",
		"older": "Show older versions"
	},
	"release": {
		"version": "v{{version}}",
		"latest": "Latest"
	},
	"kind": {
		"NEW": "New",
		"IMPROVED": "Improved",
		"FIXED": "Fixed"
	},
	"settings": {
		"open": "Who can see this page",
		"title": "Who can see Change Logs",
		"intro": "Choose which roles see this page. Super admins always see it, and only they see the other apps.",
		"rolesLabel": "Roles",
		"always": "Always",
		"changed": "Last changed {{when}}",
		"reason": "Reason",
		"reasonHint": "Shown in the activity log.",
		"reasonRequired": "Enter a reason.",
		"saved": "Saved. People see the change the next time they open the GMS.",
		"failed": "Could not save."
	}
}
